<template>
  <div class="flex overflow-visible">
    <div :class="showTag && 'flex relative overflow-visible'">
      <img
        v-if="showTag"
        :src="STPTagImage"
        class=" h-[150px] w-auto max-w-none"
      >

      <div
        :class="twMerge('flex flex-col items-center rotate-[-10deg] relative font-[800] uppercase', showTag && 'absolute top-1/2 -translate-y-1/2 right-[50px]')"
      >
        <p :class="twMerge('text-xl leading-[20px] z-[2] IWD-tag-text overflow-visible px-0.5')">
          {{ `${Math.trunc(saleValue * 100)}% off` }}
        </p>
        <p :class="twMerge('text-[15px] leading-[16px] tracking-[0.4px] z-[2] IWD-tag-text px-0.5')">
          EVERYTHING
        </p>
        <div
          v-if="!showTag"
          class="absolute left-1/2 top-1/2 w-full h-[80%] -translate-y-1/2 -translate-x-1/2 STP-shadow z-[1]"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import { useShop } from '@/composables/game/shop'
import STPTagImage from '@/assets/images/periodic/STP/STP-tag.png'

defineProps<{
  showTag?: boolean
}>()

const { saleValue } = useShop()
</script>
<style lang="scss" scoped>
@import '@/assets/styles/sales';

</style>